import { warnAndNotify } from '@execonline-inc/error-reporting.private';
import { assertNever } from '@kofno/piper';
import { Task } from 'taskarian';
import { AppyError, callApi } from '../../Appy';
import ErrorActionableReaction, { EAProps, handleError } from '../../ErrorActionableReaction';
import { MissingLinkError, findLinkT } from '../../LinkyLinky';
import { Link } from '../../Resource/Types';
import { participantsOptionsResourceDecoder } from './Decoders';
import { State } from './Types';
import ParticipantsOptionsStore from './index';

interface Props extends EAProps<ParticipantsOptionsStore> {}

type OptionsError = AppyError | MissingLinkError;

const handleOptionsError = (store: ParticipantsOptionsStore) => (error: OptionsError) => {
  switch (error.kind) {
    case 'missing-link-error':
      store.error('We are unable to process your request at this time');
      warnAndNotify('ParticipantsOptionsReactions', error.kind, error);
      break;
    default:
      handleError(store, error);
  }
};

const sendRequest = callApi(participantsOptionsResourceDecoder, {});

class ParticipantsOptionsReactions extends ErrorActionableReaction<
  ParticipantsOptionsStore,
  State,
  Props
> {
  tester = () => this.props.store.state;
  effect = (state: State) => {
    const { store } = this.props;
    switch (state.kind) {
      case 'waiting':
        break;
      case 'loading':
        Task.succeed<OptionsError, ReadonlyArray<Link>>(store.participantsStore.links)
          .andThen(findLinkT('options'))
          .andThen(sendRequest)
          .fork(handleOptionsError(store), store.ready);
        break;
      case 'ready':
      case 'error':
        break;
      default:
        assertNever(state);
    }
  };
}

export default ParticipantsOptionsReactions;
